export const INITIAL_STATE = {
    data: [],
    isFetching: false,
    error: false
  }

  export const request = (state, action) => {
    return {
      ...state,
      data: [],
      isFetching: true
    }
  }
  
  export const success = (state, action) => {
    return {
      ...state,
      data: action.data,
      isFetching: false,
      error: false
    }
  }
  
  export const failure = (state, action) => {
    return {
      ...state,
      data: action.errData,
      isFetching: false,
      error: true
    }
  }

  export const requestOneClinic = (state, action) => {
    return {
      ...state,
      dataOneClinic: {},
      isFetchingOneClinic: true
    }
  }

  export const successOneClinic = (state, action) => {
    return {
      ...state,
      dataOneClinic: action.data,
      isFetchingOneClinic: false,
      errorOneClinic: false
    }
  }

  export const failureOneClinic = (state, action) => {
    return {
      ...state,
      dataOneClinic: {},
      isFetchingOneClinic: false,
      errorOneClinic: true
    }
  }

  export const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case 'REQ_GET_CLINIC_REQUESTED':
        return request(state, action)
      case 'REQ_GET_CLINIC_SUCCEEDED':
        return success(state, action)
      case 'REQ_GET_CLINIC_FAILED':
        return failure(state, action)
      case 'REQ_GET_ONE_CLINIC_REQUESTED':
        return requestOneClinic(state, action)
      case 'REQ_GET_ONE_CLINIC_SUCCEEDED':
        return successOneClinic(state, action)
      case 'REQ_GET_ONE_CLINIC_FAILED': 
        return failureOneClinic(state, action)
      case 'RESET': 
        return INITIAL_STATE
      default:
        return state
    }
  }

